import styled from "styled-components";

export const Logo = styled.img`
    margin: 0 auto;
    box-sizing: border-box;
    padding: 5px;
    height: 3em;
    width: 3em;
`;
